module.exports = __webpack_public_path__ + "static/media/upload2.94337aa9.png";